export default __webpack_public_path__ + "static/leena3-324ea219ccbacd75a61450e6886c0bee.png";